/* Roo Roo - how the store feels in the hand.

   1. Add to Bag answers back: the button says "Added", the new line glows in
      the bag, and the bag count gives a small bump.
   2. The bag can be swiped away to the right (the way it came in), following
      the finger and finishing at the finger's own speed.
   3. Taking the last one of something out of the bag offers Undo for a few
      seconds instead of making people find and add it again.
   4. Phone photo gallery: keeps the thumbnails, zoom and colour swatches in
      step with the photo being swiped (see snippets/roo-gallery.liquid).
   5. Size chart: a bottom sheet on phones that can be dragged down, with a
      "Find your size" helper that reads the chart and picks the size.

   None of this owns the cart or product logic - roo-cart.js and
   roo-product.js still do all of that. This file only listens and adds
   feedback, so if it failed to load the store would work exactly as before. */
(function () {
  'use strict';

  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------------------------------------------------------------- spring
     Critically damped by default (no bounce). Starts from the value on
     screen with the velocity it already has, so a release after a drag
     carries straight on instead of stopping dead. */
  function spring(o) {
    var x = o.from, v = o.velocity || 0, to = o.to;
    var damping = o.damping || 1, response = reduce ? 0.18 : (o.response || 0.34);
    var k = Math.pow(2 * Math.PI / response, 2), c = 4 * Math.PI * damping / response;
    var last = performance.now(), raf = 0, done = false;
    function tick(now) {
      if (done) return;
      var dt = Math.min(0.064, (now - last) / 1000);
      last = now;
      var steps = Math.max(1, Math.ceil(dt / 0.004)), h = dt / steps;
      for (var i = 0; i < steps; i++) {
        var a = -k * (x - to) - c * v;
        v += a * h;
        x += v * h;
      }
      if (Math.abs(x - to) < 0.4 && Math.abs(v) < 4) {
        done = true;
        o.onUpdate(to);
        if (o.onRest) o.onRest();
        return;
      }
      o.onUpdate(x);
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
    return { stop: function () { done = true; cancelAnimationFrame(raf); } };
  }

  function rubber(x, dim) { var c = 0.55; return (x * dim * c) / (dim + c * Math.abs(x)); }
  function project(v) { var d = 0.998; return (v / 1000) * d / (1 - d); }

  /* Drag a panel along one axis to dismiss it.
     axis 'x': dismisses to the right. axis 'y': dismisses downward.
     handle: where a drag may start (defaults to the panel itself). */
  function dismissable(panel, axis, opts) {
    var handle = opts.handle || panel;
    var drag = null, anim = null, suppress = false;

    function size() { return axis === 'x' ? panel.offsetWidth : panel.offsetHeight; }
    function paint(offset) {
      var s = size() || 1;
      panel.style.transform = axis === 'x'
        ? 'translate3d(' + offset.toFixed(2) + 'px,0,0)'
        : 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      if (opts.onProgress) opts.onProgress(Math.max(0, Math.min(1, 1 - offset / s)));
    }
    function clear() {
      panel.style.transition = '';
      panel.style.transform = '';
      if (opts.onProgress) opts.onProgress(null);
    }

    handle.addEventListener('pointerdown', function (e) {
      if (!opts.enabled()) return;
      if (e.pointerType === 'mouse') return;
      if (anim) { anim.stop(); anim = null; }
      suppress = false;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, on: false, hist: [], start: 0 };
    });

    handle.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      var main = axis === 'x' ? dx : dy, cross = axis === 'x' ? dy : dx;
      if (!drag.on) {
        if (Math.abs(main) < 10 && Math.abs(cross) < 10) return;
        if (Math.abs(main) <= Math.abs(cross) || main < 0) { drag = null; return; }
        if (opts.canStart && !opts.canStart()) { drag = null; return; }
        drag.on = true;
        suppress = true;
        try { handle.setPointerCapture(e.pointerId); } catch (err) {}
        panel.style.transition = 'none';
        var m = /translate3d\(([-\d.]+)px,\s*([-\d.]+)px/.exec(panel.style.transform || '');
        drag.start = m ? parseFloat(axis === 'x' ? m[1] : m[2]) : 0;
      }
      var off = drag.start + main;
      if (off < 0) off = rubber(off, size());
      paint(off);
      drag.off = off;
      drag.hist.push({ p: axis === 'x' ? e.clientX : e.clientY, t: e.timeStamp });
      if (drag.hist.length > 6) drag.hist.shift();
    });

    function end(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null;
      if (!d.on) return;
      var a = d.hist[0], b = d.hist[d.hist.length - 1];
      var vel = (a && b && b.t > a.t) ? (b.p - a.p) / ((b.t - a.t) / 1000) : 0;
      var s = size(), off = d.off || 0;
      if (vel > 600 || off + project(vel) > s * 0.45) {
        anim = spring({
          from: off, to: s, velocity: vel, response: 0.3,
          onUpdate: paint,
          onRest: function () {
            anim = null;
            panel.style.transition = 'none';
            suppress = false;
            opts.dismiss();
            /* The closed state puts the panel exactly where it already is, so
               dropping the inline position shows no jump. */
            requestAnimationFrame(function () {
              panel.style.transform = '';
              if (opts.onProgress) opts.onProgress(null);
              requestAnimationFrame(function () { panel.style.transition = ''; });
            });
          }
        });
      } else {
        anim = spring({
          from: off, to: 0, velocity: vel, damping: 0.85, response: 0.32,
          onUpdate: paint,
          onRest: function () { anim = null; clear(); }
        });
      }
    }
    handle.addEventListener('pointerup', end);
    handle.addEventListener('pointercancel', end);
    handle.addEventListener('click', function (e) {
      if (suppress && e.isTrusted) { suppress = false; e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  var drawer = document.getElementById('cartDrawer');
  var cartPage = document.querySelector('[data-cart-page]');

  /* ------------------------------------------------------- bag count, refresh */
  function setBagCount(count) {
    document.querySelectorAll('.bag-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('show', count > 0);
    });
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.setAttribute('aria-label', 'Bag, ' + count + ' item' + (count === 1 ? '' : 's'));
    });
    if (drawer) drawer.dataset.cartCount = String(count);
  }

  function bumpBagCount() {
    if (reduce) return;
    document.querySelectorAll('.bag-count.show').forEach(function (el) {
      el.classList.remove('roo-bump');
      void el.offsetWidth;
      el.classList.add('roo-bump');
    });
  }

  function swapChildren(target, source) {
    if (!target || !source) return;
    target.replaceChildren.apply(target, Array.prototype.map.call(source.childNodes, function (n) { return n.cloneNode(true); }));
  }

  function refreshBag() {
    var jobs = [];
    if (drawer) {
      jobs.push(fetch('/?section_id=main-cart', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swapChildren(drawer.querySelector('[data-cart-items]'), doc.querySelector('[data-cart-items]'));
        swapChildren(drawer.querySelector('[data-cart-foot]'), doc.querySelector('[data-cart-foot]'));
      }));
    }
    if (cartPage) {
      jobs.push(fetch('/cart?section_id=main', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var page = doc.querySelector('[data-cart-page]');
        if (!page) return;
        swapChildren(cartPage.querySelector('[data-cart-page-items]'), page.querySelector('[data-cart-page-items]'));
        swapChildren(cartPage.querySelector('[data-cart-page-foot]'), page.querySelector('[data-cart-page-foot]'));
      }));
    }
    jobs.push(fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && typeof cart.item_count === 'number') setBagCount(cart.item_count); }));
    return Promise.all(jobs);
  }

  /* ------------------------------------------------ 1. Add to Bag answers back */
  var pendingAdd = null;

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.submitting === 'true') return;
    var idEl = form.querySelector('[name="id"]');
    pendingAdd = {
      id: idEl ? String(idEl.value) : '',
      btn: form.querySelector('[data-add-to-cart], button[type="submit"]'),
      at: Date.now()
    };
  }, true);

  function markAdded() {
    var p = pendingAdd;
    pendingAdd = null;
    if (!p || Date.now() - p.at > 15000) return;

    var row = p.id && drawer ? drawer.querySelector('[data-cart-items] [data-variant-id="' + p.id + '"]') : null;
    if (row) {
      row.classList.add('roo-just-added');
      if (row.scrollIntoView) row.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { row.classList.remove('roo-just-added'); }, 1800);
    }
    bumpBagCount();

    var label = p.btn && p.btn.querySelector('[data-add-to-cart-label]');
    if (label) {
      var was = label.textContent;
      label.textContent = 'Added ✓';
      p.btn.classList.add('roo-added');
      setTimeout(function () {
        if (label.textContent === 'Added ✓') label.textContent = was;
        p.btn.classList.remove('roo-added');
      }, 1600);
    }
    if (navigator.vibrate && !reduce) { try { navigator.vibrate(8); } catch (err) {} }
  }

  if (drawer) {
    var itemsBox = drawer.querySelector('[data-cart-items]');
    if (itemsBox && window.MutationObserver) {
      new MutationObserver(function () {
        if (pendingAdd) markAdded();
      }).observe(itemsBox, { childList: true });
    }
  }

  /* --------------------------------------------- 2. swipe the bag away (right) */
  if (drawer) {
    var panel = drawer.querySelector('.cart-drawer-panel');
    var overlay = drawer.querySelector('.cart-drawer-overlay');
    var closeBtn = drawer.querySelector('.cart-drawer-head [data-cart-close]');
    if (panel && closeBtn) {
      dismissable(panel, 'x', {
        enabled: function () { return drawer.classList.contains('is-open'); },
        onProgress: function (p) {
          if (!overlay) return;
          if (p === null) { overlay.style.transition = ''; overlay.style.opacity = ''; return; }
          overlay.style.transition = 'none';
          overlay.style.opacity = String(p);
        },
        dismiss: function () { closeBtn.click(); }
      });
    }
  }

  /* ------------------------------------------ 3. Undo after taking a piece out */
  var removed = null, toastTimer = 0;

  function toastFor(root) {
    var host = root === drawer ? drawer.querySelector('.cart-drawer-panel') : root;
    if (!host) return null;
    var t = host.querySelector(':scope > .roo-undo');
    if (!t) {
      t = document.createElement('div');
      t.className = 'roo-undo';
      t.setAttribute('role', 'status');
      t.innerHTML = '<span class="roo-undo__text"></span><button type="button" class="roo-undo__btn">Undo</button>';
      if (root === drawer) {
        var head = host.querySelector('.cart-drawer-head');
        if (head && head.nextSibling) host.insertBefore(t, head.nextSibling); else host.appendChild(t);
      } else {
        var items = root.querySelector('[data-cart-page-items]');
        root.insertBefore(t, items || root.firstChild);
      }
      t.querySelector('.roo-undo__btn').addEventListener('click', undo);
    }
    return t;
  }

  function hideToast() {
    clearTimeout(toastTimer);
    document.querySelectorAll('.roo-undo.is-shown').forEach(function (t) { t.classList.remove('is-shown'); });
  }

  function showToast(root, title) {
    var t = toastFor(root);
    if (!t) return;
    t.querySelector('.roo-undo__text').textContent = 'Removed ' + title;
    var btn = t.querySelector('.roo-undo__btn');
    btn.disabled = false;
    btn.textContent = 'Undo';
    t.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { hideToast(); removed = null; }, 6000);
  }

  document.addEventListener('click', function (e) {
    var dec = e.target && e.target.closest && e.target.closest('[data-qty-decrease]');
    if (!dec) return;
    var root = dec.closest('#cartDrawer, [data-cart-page]');
    var row = dec.closest('[data-cart-line]');
    if (!root || !row || !row.dataset.variantId) return;
    var qtyEl = row.querySelector('[data-qty-value]');
    var q = parseInt(qtyEl && qtyEl.textContent, 10);
    if (q !== 1) return;
    removed = { id: row.dataset.variantId, title: row.dataset.itemTitle || 'item', at: Date.now(), root: root };
    showToast(root, removed.title);
  }, true);

  function undo(e) {
    var btn = e.currentTarget;
    var r = removed;
    if (!r) { hideToast(); return; }
    btn.disabled = true;
    clearTimeout(toastTimer);
    /* Let the removal reach the store first, or the two requests could race. */
    var wait = Math.max(0, 900 - (Date.now() - r.at));
    setTimeout(function () {
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(r.id, 10), quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        removed = null;
        return refreshBag();
      }).then(function () {
        hideToast();
        bumpBagCount();
      }).catch(function () {
        btn.textContent = 'Couldn’t add it back';
        toastTimer = setTimeout(hideToast, 3000);
      });
    }, wait);
  }

  /* -------------------------------------------- 4. phone gallery, kept in step */
  var gal = document.querySelector('[data-roo-gal]');
  if (gal) {
    var track = gal.querySelector('[data-roo-gal-track]');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('.roo-gal__slide'));
    var dots = Array.prototype.slice.call(gal.querySelectorAll('.roo-gal__dot'));
    var media = gal.closest('.pdp-media');
    var strip = document.querySelector('[data-product-thumb-strip]');
    var shown = 0, ticking = false;

    /* roo-product.js has its own "swipe past 48px to jump" on the photo.
       The gallery scrolls natively instead, so its touches stop here. */
    ['touchstart', 'touchend'].forEach(function (type) {
      track.addEventListener(type, function (ev) { ev.stopPropagation(); }, { passive: true });
    });

    function thumbFor(id) {
      return strip ? strip.querySelector('.product-thumb-item[data-media-id="' + id + '"]') : null;
    }

    function setActiveThumb(i) {
      var slide = slides[i];
      if (!slide || !strip) return;
      var thumb = thumbFor(slide.getAttribute('data-media-id'));
      if (!thumb) return;
      strip.querySelectorAll('.product-thumb-item').forEach(function (t) {
        var on = t === thumb;
        t.classList.toggle('active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
    }

    function onScroll() {
      ticking = false;
      var w = track.clientWidth || 1;
      var i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
      if (i === shown) return;
      shown = i;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      setActiveThumb(i);
    }

    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });

    /* Scripts that ran before this one (a colour picked on load, or a
       ?variant= link) may already have moved the active thumbnail. Start the
       gallery on that photo instead of the first. */
    (function () {
      var active = strip && strip.querySelector('.product-thumb-item.active[data-media-id]');
      if (!active) return;
      var id = active.getAttribute('data-media-id');
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-media-id') === id) {
          if (n > 0) {
            track.scrollLeft = slides[n].offsetLeft;
            shown = n;
            dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
          }
          break;
        }
      }
    })();

    /* A tapped thumbnail (or a colour swatch, which taps one) moves the gallery. */
    document.addEventListener('click', function (ev) {
      var thumb = ev.target && ev.target.closest && ev.target.closest('.product-thumb-item');
      if (!thumb || !strip || !strip.contains(thumb)) return;
      if (thumb.getAttribute('data-media-type') === 'video') {
        if (media) media.classList.add('is-video');
        return;
      }
      if (media) media.classList.remove('is-video');
      var id = thumb.getAttribute('data-media-id');
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-media-id') === id) {
          track.scrollTo({ left: slides[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          break;
        }
      }
    });
  }

  /* --------------------------------- 5. size chart: sheet + find your size */
  var chart = document.querySelector('[data-size-chart-modal]');
  if (chart) {
    var sheet = chart.querySelector('.size-chart-panel');
    var chartHead = chart.querySelector('.size-chart-head');
    var chartClose = chart.querySelector('.size-chart-head [data-size-chart-close]');
    var chartVeil = chart.querySelector('.size-chart-overlay');
    var sheetMQ = window.matchMedia ? matchMedia('(max-width: 640px)') : { matches: false };

    if (sheet && chartHead && chartClose) {
      var grab = document.createElement('div');
      grab.className = 'roo-grab';
      grab.setAttribute('aria-hidden', 'true');
      grab.innerHTML = '<span></span>';
      sheet.insertBefore(grab, sheet.firstChild);

      [grab, chartHead].forEach(function (h) {
        dismissable(sheet, 'y', {
          handle: h,
          enabled: function () { return sheetMQ.matches && chart.classList.contains('is-open') && !reduce; },
          onProgress: function (p) {
            if (!chartVeil) return;
            if (p === null) { chartVeil.style.opacity = ''; return; }
            chartVeil.style.opacity = String(p);
          },
          dismiss: function () { chartClose.click(); }
        });
      });
    }

    buildFinder(chart);
  }

  function nums(text) {
    var m = String(text || '').match(/\d+(?:\.\d+)?/g);
    if (!m) return null;
    var a = parseFloat(m[0]), b = parseFloat(m[m.length - 1]);
    return { min: Math.min(a, b), max: Math.max(a, b) };
  }

  /* The size guide can show cm; the inch value it was entered in stays on data-in. */
  function inches(td) { return td ? (td.getAttribute('data-in') || td.textContent) : ''; }

  function buildFinder(modal) {
    var table = modal.querySelector('.size-chart-table');
    var scroll = modal.querySelector('.size-chart-scroll');
    if (!table || !scroll) return;
    var heads = table.querySelectorAll('thead th');
    var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr')).map(function (tr) {
      var th = tr.querySelector('th'), tds = tr.querySelectorAll('td');
      return { tr: tr, size: th ? th.textContent.trim() : '', a: nums(inches(tds[0])), b: nums(inches(tds[1])) };
    }).filter(function (r) { return r.size && r.a && r.b; });
    if (rows.length < 2 || heads.length < 3) return;

    function headLabel(th) {
      var t = th.firstChild && th.firstChild.nodeType === 3 ? th.firstChild.textContent : th.textContent;
      return (t || '').trim();
    }
    var labelA = headLabel(heads[1]) || 'Chest', labelB = headLabel(heads[2]) || 'Waist';

    var box = document.createElement('div');
    box.className = 'roo-fit';
    box.innerHTML =
      '<p class="roo-fit__title">Find your size</p>' +
      '<div class="roo-fit__row">' +
        '<label class="roo-fit__field"><span></span><input type="number" inputmode="decimal" min="20" max="70" step="0.5" placeholder="inches" data-fit-a></label>' +
        '<label class="roo-fit__field"><span></span><input type="number" inputmode="decimal" min="18" max="70" step="0.5" placeholder="inches" data-fit-b></label>' +
      '</div>' +
      '<div class="roo-fit__out" aria-live="polite"><p class="roo-fit__result" data-fit-result></p>' +
      '<button type="button" class="roo-fit__pick" data-fit-pick hidden></button></div>';
    box.querySelectorAll('.roo-fit__field span')[0].textContent = labelA;
    box.querySelectorAll('.roo-fit__field span')[1].textContent = labelB;
    scroll.parentNode.insertBefore(box, scroll);

    var inA = box.querySelector('[data-fit-a]'), inB = box.querySelector('[data-fit-b]');
    var out = box.querySelector('[data-fit-result]'), pick = box.querySelector('[data-fit-pick]');
    var chosen = null;

    function isCm() { return modal.getAttribute('data-unit') === 'cm'; }

    function val(input) {
      var n = parseFloat(input.value);
      if (isNaN(n) || n <= 0) return null;
      return isCm() ? Math.round(n / 2.54 * 2) / 2 : n;
    }

    function applyUnit() {
      var cm = isCm();
      [inA, inB].forEach(function (input) {
        input.placeholder = cm ? 'cm' : 'inches';
        input.min = cm ? '45' : '18';
        input.max = cm ? '180' : '70';
        input.step = cm ? '1' : '0.5';
      });
    }

    modal.addEventListener('roo:unit', function () {
      /* Carry typed numbers across, so a switch never leaves a wrong answer. */
      var cm = isCm();
      [inA, inB].forEach(function (input) {
        var n = parseFloat(input.value);
        if (!isNaN(n) && n > 0) input.value = cm ? String(Math.round(n * 2.54)) : String(Math.round(n / 2.54 * 2) / 2);
      });
      applyUnit();
      update();
    });

    function update() {
      var a = val(inA), b = val(inB);
      rows.forEach(function (r) { r.tr.classList.remove('roo-fit-row'); });
      pick.hidden = true;
      chosen = null;
      if (a === null && b === null) { out.textContent = ''; return; }

      var match = null;
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if ((a === null || a <= r.a.max) && (b === null || b <= r.b.max)) { match = r; break; }
      }
      if (!match) {
        out.textContent = 'You’re above our chart — message us on WhatsApp and we’ll make it to your measurements.';
        return;
      }
      match.tr.classList.add('roo-fit-row');
      var onEdge = (a !== null && a === match.a.max) || (b !== null && b === match.b.max);
      out.textContent = 'We’d go with ' + match.size + '.' + (onEdge ? ' You’re right on the line, so size up if you like a roomier fit.' : '');
      var pill = document.querySelector('.size-pills button[data-value="' + match.size.replace(/"/g, '\\"') + '"]');
      if (pill && !pill.disabled) {
        chosen = pill;
        pick.textContent = 'Select ' + match.size;
        pick.hidden = false;
      } else if (pill && pill.disabled) {
        out.textContent += ' ' + match.size + ' is sold out right now.';
      }
    }

    applyUnit();
    inA.addEventListener('input', update);
    inB.addEventListener('input', update);
    pick.addEventListener('click', function () {
      if (!chosen) return;
      chosen.click();
      var closer = modal.querySelector('.size-chart-head [data-size-chart-close]');
      if (closer) closer.click();
    });
  }
})();
